export const styles = {
  dialogPaper: {
    width: "800px",
    minHeight: "400px",
    backgroundColor: "#FFFFFF",
    position: "relative",
  },
  loadingOverlay: {
    position: "absolute",
    zIndex: 9999,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255,255,255,0.80)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
  },
  titleText: {
    fontFamily: "'Ubuntu', Arial, sans-serif",
    marginTop: "4px",
  },
  closeButton: {
    position: "absolute",
    top: "12px",
    right: "16px",
    background: "#f0f0f0",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
    color: "#333",
    padding: "4px",
    lineHeight: 1,
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  subtitle: {
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "16px",
    fontWeight: "400",
    color: "#33323D",
    lineHeight: "100%",
    textAlign: "left",
  },
  cardContainer: {
    width: "364px",
    height: "100%",
    borderRadius: "16px",
    border: "1px solid #8E929F",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
    marginLeft: "16px",
  },
  cardTitle: {
    textAlign: "left",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    marginLeft: "16px",
    marginTop: "16px",
  },
  cardDescription: {
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "14px",
    fontWeight: "400",
    color: "#33323D",
    marginLeft: "16px",
    marginRight: "16px",
    textAlign: "left",
    marginTop: "20px",
    marginBottom: "16px",
  },
  cardButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "auto",
    marginBottom: "16px",
  },
  downloadButton: {
    height: "40px",
    width: "332px",
  },
  badgeContainer: {
    width: "131px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    background: "#E6F7EE",
    borderRadius: "999px",
    color: "#12836C",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontWeight: 700,
    fontSize: "10px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
  },
  badgeIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#12836C",
    borderRadius: "50%",
    width: "16px",
    height: "16px",
  },
};
